import { fromJS } from 'immutable'
import { apiInitialState, apiNamespaceReducer } from 'common/reducers/api'

const initialState = fromJS({
  ...apiInitialState('list'),
  ...apiInitialState('history')
})

function reducer(state = initialState, action) {
  const apiResult = apiNamespaceReducer(state, action, 'usage', initialState)
  if (apiResult) {
    return apiResult
  }

  switch (action.type) {
    default:
      return state
  }
}

export default reducer
